import Header from "../components/header";
import NotFound from "../components/not-found";

const NotFoundPage = () => {
  return (
    <>
      <Header />
      <NotFound />
    </>
  );
};

export default NotFoundPage;
